var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"chat",attrs:{"fluid":""}},[_c('v-row',{staticClass:"stick-g",attrs:{"elevation":"4"}},[_c('Channels'),_c('Messages'),_c('Destinataire')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }